/**
 * Accordion
 */
const accordionToggles = document.getElementsByClassName('accordion-toggle');

const toggleAccordion = function() {
    const item = this.closest('.accordion-item');
    const toggle = this.closest('.accordion-toggle');
    const content = item.querySelector('.accordion-content');

    // Remove 'aria-expanded' attribute from all other accordion items and close their content
    for (let i = 0; i < accordionToggles.length; i++) {
        const otherItem = accordionToggles[i].closest('.accordion-item');
        const otherContent = otherItem.querySelector('.accordion-content');
        if (otherItem !== item) {
            otherItem.removeAttribute('aria-expanded');
            otherContent.style.maxHeight = null;
        }
    }

    // Toggle 'aria-expanded' attribute on the clicked item
    if (item.getAttribute('aria-expanded') === 'true') {
        item.removeAttribute('aria-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
    } else {
        item.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
    }
};

for (let i = 0; i < accordionToggles.length; i++) {
    accordionToggles[i].addEventListener('click', toggleAccordion);
}
